<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[
        {
          name: 'Contact-Worldwide Offices List',
          to: { path: '/contact-worldwide-offices-list' },
        },
      ]"
    ></BreadScrumbs>
    <!-- page-actions：據點清單目前前台未使用，2026-08-22 隱藏 -->
    <div v-if="false" class="page-actions">
      <h2>Contact-Worldwide Offices List</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="createHandler">
        <v-icon class="pr-2 white--text">add</v-icon>
        <span>新增據點</span>
      </button>
    </div>
    <!-- block：據點清單目前前台未使用，2026-08-22 隱藏 -->
    <div v-if="false" class="block mb-5">
      <ContactPageTable class="mb-5"></ContactPageTable>
    </div>
    <!-- NewsCenter PageTitle -->
    <div class="page-actions">
      <h2>ContactUs Page Info</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="toContactPageTitle">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
    </div>
    <div class="block" v-if="pageTitle != null">
      <!-- PageTitle -->
      <div class="form-item py-5 d-flex">
        <div class="w-94px mr-166px">
          <h4>PageTitle</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          {{ pageTitle.title }}
        </div>
      </div>
      <!-- Description -->
      <div class="form-item py-5 d-flex">
        <div class="w-94px mr-166px">
          <h4>Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0" v-html="pageTitle.description">
        </div>
      </div>
      <!-- Desktop -->
      <div class="form-item py-5 d-flex">
        <div class="w-94px mr-166px">
          <h4>Desktop Image</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div
            class="bg-cover bg-center"
            :style="{
              width: '480px',
              height: '76px',
              'background-image': `url(${pageTitle.image||background})`,
            }"
          ></div>
        </div>
      </div>
      <!-- Mobile -->
      <div class="form-item py-5 d-flex">
        <div class="w-94px mr-166px">
          <h4>Mobile Image</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div
            class="bg-cover bg-center"
            :style="{
              width: '480px',
              height: '76px',
              'background-image': `url(${pageTitle.image_mobile||background})`,
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import ContactPageTable from '@/views/B-6__Contact/c/ContactPageTable.vue';

export default {
  components: {
    BreadScrumbs,
    ContactPageTable,
  },
  data: () => ({
    background: 'https://dummyimage.com/480x76.jpg',
  }),
  created() {
    this.clear();
    this.getContacts();
    this.getPageTitle('contact');
  },
  computed: {
    ...mapState('pageTitle', ['pageTitle']),
  },
  methods: {
    ...mapActions('pageTitle', {
      getPageTitle: 'findByType',
    }),
    ...mapActions('contact', {
      getContacts: 'find',
      clear: 'clear',
    }),
    createHandler() {
      this.$router.push({ name: 'OfficeCreate' });
    },
    toContactPageTitle() {
      this.$router.push({ name: 'ContactPage_EditPageTitle' });
    },
  },
};
</script>

<style></style>
